/* Mobile product gallery: endless loop for the snap-centred picture row (2026-10-23).

   The row (`[data-product-media-list]`, phones only, <= 749px) is a native scroll-snap carousel, see the mobile block in
   snippets/product.liquid: the picture in focus sits in the middle with a sliver of its neighbours on both sides.
   Native scroll cannot wrap, so the row gets copies of the last pictures in front and of the first pictures behind it. When a swipe has
   SETTLED on a copy, the row jumps (instantly, snapping switched off for that frame) to the identical real picture, which the eye cannot see.

   Copies carry none of the data attributes the theme looks pictures up by (data-slide, data-media-id, data-image-id, data-zoom-image), are
   aria-hidden and inert, so the dots, the thumbnail strip, variant scrolling and the zoom only ever see the real pictures.
   Galleries with a video or 3D model, or a single picture, are left as a plain snap row (no pp-loop class).
   list.ppCentreLeft(slide) = the scrollLeft that centres a slide; the thumbnail tap in product.liquid uses it. */
(function () {
  'use strict';
  var mq = window.matchMedia && window.matchMedia('(max-width: 749px)');
  if (!mq || !mq.matches) return;

  var COPY_ATTRS = ['data-slide', 'data-media-id', 'data-image-id', 'data-zoom-image', 'id'];

  function slidesOf(list) {
    return Array.prototype.filter.call(list.children, function (el) { return el.classList.contains('product__slide'); });
  }

  function init(list) {
    var real = slidesOf(list);
    if (real.length < 2) return;
    var allImages = real.every(function (s) { return !s.getAttribute('data-type') || s.getAttribute('data-type') === 'image'; });
    if (!allImages) return;

    var n = real.length, K = Math.min(3, n);

    function copyOf(slide) {
      var c = slide.cloneNode(true);
      [c].concat(Array.prototype.slice.call(c.querySelectorAll('*'))).forEach(function (el) {
        COPY_ATTRS.forEach(function (a) { el.removeAttribute(a); });
      });
      c.setAttribute('data-pp-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('inert', '');
      return c;
    }
    var first = real[0], last = real[n - 1];
    for (var i = n - K; i < n; i++) list.insertBefore(copyOf(real[i]), first);
    var after = last.nextSibling;
    for (var j = 0; j < K; j++) list.insertBefore(copyOf(real[j]), after);
    list.classList.add('pp-loop');

    function all() { return slidesOf(list); }
    function centreLeft(slide) {
      var l = list.getBoundingClientRect(), s = slide.getBoundingClientRect();
      return s.left - l.left + list.scrollLeft - (list.clientWidth - s.width) / 2;
    }
    list.ppCentreLeft = centreLeft;
    function nearestIndex() {
      var a = all(), best = 0, bd = Infinity, mid = list.scrollLeft;
      for (var k = 0; k < a.length; k++) {
        var d = Math.abs(centreLeft(a[k]) - mid);
        if (d < bd) { bd = d; best = k; }
      }
      return best;
    }
    function jumpTo(slide) {
      list.style.scrollSnapType = 'none';
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = centreLeft(slide);
      requestAnimationFrame(function () { requestAnimationFrame(function () { list.style.scrollSnapType = ''; }); });
    }

    // start on the first real picture. The page's own mobile boot script and late layout (images arriving) move the row too, so the start position is
    // re-applied until the visitor first touches the row.
    var touching = false, timer = 0, userMoved = false;
    jumpTo(real[0]);
    function restart() { if (!userMoved) jumpTo(real[0]); }
    document.addEventListener('DOMContentLoaded', function () { setTimeout(restart, 50); });
    window.addEventListener('load', function () { restart(); setTimeout(restart, 400); setTimeout(restart, 1500); });
    list.addEventListener('touchstart', function () { touching = true; userMoved = true; clearTimeout(timer); }, { passive: true });
    list.addEventListener('touchend', function () { touching = false; schedule(); }, { passive: true });
    list.addEventListener('touchcancel', function () { touching = false; schedule(); }, { passive: true });

    function settle() {
      if (touching) return;
      var a = all(), idx = nearestIndex();
      // is the picture in the middle a copy, and has the row stopped moving (within a pixel of its snap point)?
      if (Math.abs(centreLeft(a[idx]) - list.scrollLeft) > 1.5) return schedule();
      if (idx < K) jumpTo(a[idx + n]);                // leading copy j shows real picture n-K+j, which sits n slides further on
      else if (idx >= K + n) jumpTo(a[idx - n]);      // trailing copy j shows real picture j, n slides back
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(settle, 120); }
    list.addEventListener('scroll', schedule, { passive: true });
    if ('onscrollend' in window) list.addEventListener('scrollend', settle);

    // keep the picture in focus when the phone is turned or the window changes
    var lastW = list.clientWidth;
    window.addEventListener('resize', function () {
      if (list.clientWidth === lastW) return;
      lastW = list.clientWidth;
      var a = all(), idx = nearestIndex();
      jumpTo(a[idx]);
    });
  }

  function boot() {
    var list = document.querySelector('product-images [data-product-media-list]');
    if (list) init(list);
  }
  // after the page's own mobile boot script (it runs on DOMContentLoaded) has normalised the slides
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  else setTimeout(boot, 0);
})();
